/**
 * Card Slider
 *
 * Adds prev/next arrow navigation to .card-slider blocks.
 * Cards scroll horizontally with CSS scroll-snap.
 * Arrows are injected into .card-slider__header if it exists,
 * or created above the track.
 */

function initCardSlider(slider) {
  const track = slider.querySelector('.card-slider__track');
  if (!track) return;

  const cards = Array.from(track.querySelectorAll('.card-slider__card'));
  if (cards.length <= 1) return;

  // Inject spacer as the first flex item to offset cards to the
  // wide content edge. Width = slider left offset minus the flex gap
  // (the gap between spacer and first card completes the alignment).
  const spacer = document.createElement('div');
  spacer.className = 'card-slider__spacer';
  spacer.setAttribute('aria-hidden', 'true');
  track.prepend(spacer);

  function updateSpacerWidth() {
    // Slider's content-box left = border-box left + padding-left.
    // This is where the heading sits (inside WP global padding).
    const sliderRect = slider.getBoundingClientRect();
    const paddingLeft = parseFloat(getComputedStyle(slider).paddingLeft) || 0;
    const contentLeft = sliderRect.left + paddingLeft;
    // Spacer width = exact content offset (gap is canceled by negative margin in CSS)
    const offset = Math.max(0, contentLeft);
    spacer.style.flexBasis = offset + 'px';
    // Snap port inset so each card aligns with the wide content edge
    track.style.scrollPaddingLeft = offset + 'px';
  }

  updateSpacerWidth();

  // Ensure initial scroll shows the spacer (position 0), not snapped past it
  track.scrollLeft = 0;

  // Create arrow buttons
  const arrowContainer = document.createElement('div');
  arrowContainer.className = 'card-slider__arrows';

  const prevBtn = document.createElement('button');
  prevBtn.className = 'card-slider__arrow card-slider__arrow--prev';
  prevBtn.setAttribute('aria-label', 'Edellinen');
  prevBtn.innerHTML = '<svg viewBox="0 0 24 24"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>';

  const nextBtn = document.createElement('button');
  nextBtn.className = 'card-slider__arrow card-slider__arrow--next';
  nextBtn.setAttribute('aria-label', 'Seuraava');
  nextBtn.innerHTML = '<svg viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>';

  arrowContainer.appendChild(prevBtn);
  arrowContainer.appendChild(nextBtn);

  // Place arrows in header if available, otherwise before track
  const header = slider.querySelector('.card-slider__header');
  if (header) {
    header.appendChild(arrowContainer);
  } else {
    track.before(arrowContainer);
  }

  function updateArrows() {
    const { scrollLeft, scrollWidth, clientWidth } = track;
    prevBtn.disabled = scrollLeft <= 1;
    nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
  }

  function getScrollAmount() {
    // Scroll by one card width + gap
    const card = cards[0];
    if (!card) return 300;
    const style = getComputedStyle(track);
    const gap = parseFloat(style.gap) || 24;
    return card.offsetWidth + gap;
  }

  prevBtn.addEventListener('click', () => {
    track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', () => {
    track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', updateArrows, { passive: true });
  updateArrows();

  // Re-check on resize (card widths + spacer change)
  const ro = new ResizeObserver(() => {
    updateSpacerWidth();
    updateArrows();
  });
  ro.observe(track);
}

function init() {
  document.querySelectorAll('.card-slider').forEach(initCardSlider);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
